<template>
  <sidebar id="app-sidebar">
    <sidebar-account/>
    <sidebar-nav :items="filteredNavItems"/>
  </sidebar>
</template>

<script>
import { mapGetters } from 'vuex'
import Nav from '@/components/ui/sidebar/items'
import Sidebar from '@/components/ui/sidebar/Sidebar.vue'
import SidebarNav from '@/components/ui/sidebar/nav/index.vue'
import SidebarAccount from '@/components/ui/sidebar/Account.vue'

export default {
  name: 'SidebarContainer',
  components: {
    Sidebar,
    SidebarNav,
    SidebarAccount
  },
  data() {
    return {
      filteredNavItems: []
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser'
    })
  },
  created() {
    this.filteredNavItems = this.getFilteredNav(Nav.items)
  },
  methods: {
    getFilteredNav(navItems) {
      const navItems1 = navItems.filter((navItem) => {
        if (!navItem.permission && !navItem.ids) {
          return true
        }
        if (navItem.permission) {
          for (let i = 0; i < navItem.permission.length; i++) {
            if (this.hasRole(navItem.permission[i])) {
              return true
            }
          }
        }
        if(navItem.ids) {
          return navItem.ids.includes(this.currUser.id)
        }
        return false
      })
      for (let i = 0; i < navItems1.length; i++) {
        if (navItems1[i].children) {
          navItems1[i].children = this.getFilteredNav(navItems1[i].children)
        }
      }
      return navItems1
    }
  }
}
</script>

<style scoped>

</style>
